import React, { useState } from 'react'
import ordersumStyle from './ordersummaryInfo.module.css'
require('typeface-poppins')

export default function OrdersummaryInfo() {

    const [openIndex, setOpenIndex] = useState(null); // state to track open accordion item, null means none are open

    const handleToggle = (index) => {
        // Toggle between opening and closing the same accordion item
        setOpenIndex(openIndex === index ? null : index);
    };

    return (
        <>
            <div className={`${ordersumStyle.odersumAccordion} accordion mb-3`} id="ordersummaryInfo">
                <div className={`${ordersumStyle.odersumMainitem} accordion-item`}>
                    <h2 className="accordion-header">
                        <button className={`${ordersumStyle.odersumbuttonItem} ${ordersumStyle.odersumBeforebg} accordion-button ${openIndex === 0 ? '' : `${ordersumStyle.odersumbgColor} collapsed`}`} type="button" onClick={() => handleToggle(0)} aria-expanded={openIndex === 0 ? 'true' : 'false'} aria-controls="collapseOne">
                            Order Summary
                        </button>
                    </h2>
                    <div id="collapseOne" className={`accordion-collapse collapse ${openIndex === 0 ? 'show' : ''}`} data-bs-parent="#ordersummaryInfo">
                        <div className={`${ordersumStyle.odersummoreBody} accordion-body`}>
                            <div className={ordersumStyle.odersuminfoWrapper}>
                                <div className={ordersumStyle.odersumInner}>
                                    <div className={`${ordersumStyle.odersumInfoleft} w-50`}>
                                        <h6> Subtotal </h6>
                                    </div>
                                    <div className={`${ordersumStyle.odersumInforight} w-50 text-end`}>
                                        <p> $00.00 </p>
                                    </div>
                                </div>
                                <div className={ordersumStyle.odersumInner}>
                                    <div className={`${ordersumStyle.odersumInfoleft} w-50`}>
                                        <h6> Tax </h6>
                                    </div>
                                    <div className={`${ordersumStyle.odersumInforight} w-50 text-end`}>
                                        <p> $00.00 </p>
                                    </div>
                                </div>
                                <div className={`${ordersumStyle.odersumInner} pb-0`}>
                                    <div className={`${ordersumStyle.odersumInfoleft} w-50`}>
                                        <h6> <strong> Grand Total </strong> </h6>
                                    </div>
                                    <div className={`${ordersumStyle.odersumInforight} w-50 text-end`}>
                                        <p> <strong> $00.00 </strong> </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
